<template>
	<div class="dubbingBox" v-show="dubFlag" ref="dubbingBox">
		<div class="dubbingSp">
			<div class="dubbingBtns">
				<div class="dubbingBtn" @click="fhFn">
					<img src="@/assets/img/编组 6.svg" alt="" />
					<span>关闭</span>
				</div>
				<div class="dubbingBtn dubbingBtn1" @click="singBtn">
					<img src="@/assets/img/yys.svg" alt="" />
					<span>{{ singFlag ? '静音' : '原声' }}</span>
				</div>
			</div>
			<div class="dubbingVideo">
				<video
					ref="videoPlayer"
					class="video-js vjs-default-skin mysVideo"
					controls
					:muted="isMuted"
					@play="vplay"
					@pause="vpause"
					preload="auto"
					height="500"
					data-setup="{}"
				>
					<source :src="videoUrl" type="video/mp4" />
					<source :src="$httpUrl + videoUrl" type="video/mov" />
					<!-- 其他视频源 -->
				</video>
				<audio ref="myAudio" :currentTime="currentTime" class="myAudio">
					<source :src="audioUrl" type="audio/mpeg" />
					<source :src="audioUrl" type="audio/ogg" />
					Your browser does not support this audio format.
				</audio>
			</div>
		</div>
		<div class="dubbingRig">
			<div class="dubbingRigH">
				<div class="dubbingRigS" :style="{ top: screenHeight / 2 - 130 + -rigTop + 'px' }">
					<div
						class="dubbingRigItem"
						:ref="'rigItem' + (index + 1)"
						:class="item.htmlText == subtitleText ? 'videoActive' : ''"
						v-for="(item, index) in srtMap"
						:key="index"
					>
						{{ item.htmlText }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import axios from 'axios';

export default {
	name: 'dubbingVideo',
	props: {
		dubFlag: {
			type: Boolean,
			default: false
		},
		currentTimes: {
			type: Number,
			default: 0
		},
		coverImg: {
			type: String,
			default: ''
		},
		videoUrl: {
			type: String,
			default: ''
		},
		subtitlingUrl: {
			type: String,
			default: ''
		},
		audioUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			srtMap: [],
			randomInt: 1,
			screenHeight: window.innerHeight,
			rigTop: '',
			player: '',
			currentTime: 0,
			subtitleText: '',
			singPlayer: '',
			singFlag: true,
			isMuted: true,
			videoPlayer: '',
			isVPlaying: false
		};
	},
	watch: {
		currentTime: {
			immediate: true,
			handler(newTime) {
				//根据字幕切换选择所需要的字幕数组
				if (this.currentTime) {
					this.$refs.myAudio.currentTime = newTime;
					this.subtitleText = this.getSubtitle(this.currentTime, this.srtMap);
				}
			}
		},
		subtitleText() {
			this.$nextTick(() => {
				this.screenHeight = window.innerHeight;
				this.rigTop = this.$refs['rigItem' + this.randomInt][0].offsetTop;
			});
		}
	},
	methods: {
		// 全屏
		onFullScreen() {
			if (this.fullscreen) {
				this.$fullscreen.exit(); //退出全屏
				this.fullscreen = '';
				this.$emit('gbFn');
			} else {
				// 通过ref拿到具体的、希望全屏展示的元素
				let dom = this.$refs['dubbingBox'];
				//打开全屏
				this.$fullscreen.enter(dom, {
					wrap: false,
					callback: (f) => {
						this.fullscreen = f;
					}
				});
			}
		},
		setupFullscreenListener() {
			document.addEventListener('fullscreenchange', this.onFullscreenChange);
		},
		removeFullscreenListener() {
			document.removeEventListener('fullscreenchange', this.onFullscreenChange);
		},
		onFullscreenChange() {
			if (!document.fullscreenElement) {
				console.log('已退出全屏');
				this.onFullScreen();
				this.$emit('gbFn');
				// 执行你的退出全屏后的逻辑
			}
		},
		fhFn() {
			this.vpause();
			this.videoPlayer.pause();
			this.onFullScreen();
			this.$emit('fhFn', false);
		},
		vplay() {
			this.isVPlaying = true;
			// if(this.singFlag){
			//   this.singPlayer.play()
			// }
		},
		vpause() {
			this.isVPlaying = false;
			// if(this.singFlag){
			//   this.singPlayer.pause()
			// }
		},
		singBtn() {
			this.singFlag = !this.singFlag;
			this.isMuted = !this.isMuted;
			// if(!this.singFlag){
			//   // this.singPlayer.pause();
			// }else{
			//   if(this.isVPlaying){
			//     // this.singPlayer.play();
			//   }
			// }
		},
		updateCurrentTime() {
			if (this.videoPlayer) {
				this.currentTime = this.videoPlayer.currentTime;
			}
		},
		async init() {
			// 监听video的timeupdate事件来更新currentTime
			this.$nextTick(() => {
				// this.singPlayer = this.$refs.myAudio;
				this.videoPlayer = this.$refs.videoPlayer;

				this.videoPlayer.addEventListener('timeupdate', this.updateCurrentTime);
				this.player = videojs(
					this.videoPlayer,
					{
						controlBar: {
							fullscreenToggle: false, // 隐藏全屏按钮
							pip: false
						}
					},
					function onPlayerReady() {
						console.log('Player is ready');
					}
				);
			});
			// this.$http.get(new URL(this.subtitlingUrl, import.meta.url)).then(res => {
			//   this.srtMap = this.createSrtArr(res)
			//   console.log(this.srtMap,99999)
			// })
			const response = await axios.get(this.subtitlingUrl);
			let res = response.data;
			this.srtMap = this.createSrtArr(res);
			console.log(this.srtMap, 99999);
		},
		createSrtArr(srt) {
			let arr = srt?.split(/\n\n|\r\r|\r\n\r\n/);
			let result = [];
			arr.forEach((item) => {
				let srtObj = {};
				let containArr = item?.split(/\n/);
				if (containArr[1]) {
					//此处正则用于取出00:00:00，213 --> 00:00:00，213这种结构，防止可能存在于此行的x，y坐标对后续处理造成影响
					let reg = /^(\d{1,2}):(\d{1,2}):(\d{1,2})[\.,](\d{1,3}) --\> (\d{1,2}):(\d{1,2}):(\d{1,2})[\.,](\d{1,3})/g;
					let regResult = reg.exec(containArr[1]);
					if (regResult) {
						let timeSplit = regResult[0]?.split(' --> ');
						srtObj.from = this.getSeconds(timeSplit[0]);
						srtObj.to = this.getSeconds(timeSplit[1]);
						//这里的两个replace主要是将srt中可能携带的font标签转化为易用的span，当时遇到了如果是font标签的话没办法继承父元素的字体大小的问题，题外话：本次字母字体大小采用了媒体查询进行设置
						srtObj.htmlText = containArr
							.slice(2)
							.join(`<br/>`)
							.replace(/\<font/g, '<span')
							.replace(/\<\/font/g, '</span');
						result.push(srtObj);
					}
				}
			});
			return result;
		},
		//将srt中的字符串时间转化为所需要的格式，这里转化成了秒数
		getSeconds(val) {
			let arr = val?.split(/\,|\./);
			let sec = 0;
			let a = arr[0]?.split(':');
			sec = Number(a[0]) * 60 * 60 + Number(a[1]) * 60 + Number(a[2]) + arr[1] / 1000;
			return sec;
		},
		getSubtitle(currentTime, arr) {
			let low = 0,
				high = arr.length;
			let mid, htmlText;
			while (low <= high) {
				mid = parseInt((low + high) / 2);
				if (arr[mid].from <= currentTime && arr[mid].to >= currentTime) {
					this.randomInt = mid + 1;
					htmlText = arr[mid].htmlText;
					break;
				}
				if (arr[mid].from > currentTime) {
					high = mid - 1;
				}
				if (arr[mid].to < currentTime) {
					low = mid + 1;
				}
			}
			return htmlText;
		}
	},
	mounted() {
		console.log(this.videoUrl, 88888);
		this.setupFullscreenListener();
		this.init();
	},
	beforeDestroy() {
		if (this.player) {
			this.player.dispose();
		}
		this.removeFullscreenListener();
		// 移除事件监听器
		this.videoPlayer.removeEventListener('timeupdate', this.updateCurrentTime);
	}
};
</script>
<style lang="scss" scoped>
.dubbingBox {
	position: fixed;
	z-index: 9999999;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	display: flex;
	.dubbingRig {
		height: 100vh;
		overflow: hidden;
		box-sizing: border-box;
		width: 42vw;
		background: #202020;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #878787;
		text-align: center;
		font-size: 22px;
		line-height: 1.8;
		padding: 75px 31px;
		.dubbingRigH {
			overflow: hidden;
			.dubbingRigS {
				position: relative;
				transition: all 1.5s;
			}
		}
		.dubbingRigItem {
			margin-bottom: 6px;
		}
		.videoActive {
			color: #35be5f;
		}
	}
	.dubbingSp {
		height: 100vh;
		width: 58vw;
		background: #171717;
		display: flex;
		align-items: center;
		position: relative;
		.dubbingBtns {
			position: absolute;
			display: flex;
			justify-content: space-between;
			padding: 0 20px;
			box-sizing: border-box;
			width: 100%;
			top: 30px;
			.dubbingBtn {
				width: 80px;
				height: 30px;
				background: rgba(255, 255, 255, 0.11);
				border-radius: 18px;
				border: 1px solid #ffffff;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				color: #fff;
				cursor: pointer;
				img {
					width: 13px;
					height: 12px;
					margin-right: 5px;
				}
			}
			.dubbingBtn1 {
				img {
					width: 17px;
					height: 17px;
				}
				i {
					margin-right: 8px;
				}
			}
		}
		.dubbingVideo {
			height: 500px;
			width: 100%;
			.mysVideo {
				width: 100% !important;
				height: 500px;
				border-radius: 6px;
				margin-bottom: 23px;
			}
		}
	}
	.dubbingRig {
		width: 42vw;
	}
}
</style>
